import React from 'react';
import "./style.css";
import CreateCompanyFooter from '../components/createcompanyfooter/CreateCompanyFooter';

const Legalguidelines = () => {
    return (
        <div>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-8'>
                        <div>
                            <h4 className='guidelines_text_h4 pt-4'>Guidelines</h4>
                            <p className='guidelines_text_p mb-2'>These are the official posting guidelines (“Site Guidelines”) for the Rate My Manager website, application, or other interactive service (“Site”). The Site is owned and operated by <b>Rate My Manager, Inc.</b> (“Rate My Manager,” “we,” “us,” or “our”). These Site Guidelines are part of our Terms of Use.</p>

                            <p className='guidelines_text_p'>
                                <b>Rate My Manager</b> exists to provide a safe platform for professionals to share their experiences working with engineering managers. Our mission is to promote transparency, accountability, and growth in workplace leadership through honest and constructive peer feedback.
                            </p>

                            <h4 className='guidelines_text_h5'>THE SITE/APP</h4>
                            <p className='guidelines_text_p'>
                                The <b>Rate My Manager</b> platform provides user-generated feedback on managers’ leadership and communication skills. Manager profiles can be created by users and are not subject to prior approval. Ratings must come from individuals who have directly worked with the manager. Verified reviews require the user to sign up using their company email; unverified reviews do not affect the manager's rating.
                            </p>
                            <p className='guidelines_text_p'>
                                <b>Rate My Manager</b> is <b>not</b> the appropriate venue for reporting dangerous, unlawful, or threatening conduct. Please report such matters to the appropriate workplace authorities or law enforcement.
                            </p>

                            <h4 className='guidelines_text_h5'>HOW WE WORK</h4>
                            <p className='guidelines_text_p'>
                                Every review is subject to moderation before publishing. Our team reviews flagged content against these guidelines. Reviews are not removed solely for being negative or critical — only when they violate our content policies.
                            </p>
                            <p className='guidelines_text_p'>
                                You can report a review for re-evaluation, but we do not guarantee removal unless content clearly violates guidelines.
                            </p>

                            <h4 className='guidelines_text_h5'>User Guidelines</h4>
                            <ul className='guidelines_text_ul'>
                                <li>Be honest, constructive, and relevant to the workplace.</li>
                                <li>Focus feedback on the manager’s professional behavior, not personal traits.</li>
                                <li>Avoid unverified hearsay and personal attacks.</li>
                                <li>Preserve anonymity — avoid identifying information.</li>
                                <li>No retaliation, harassment, or emotional rants.</li>
                                <li>Limit one review per manager per tenure.</li>
                            </ul>

                            <h4 className='guidelines_text_h5'>Prohibited Content</h4>
                            <ul className='guidelines_text_ul'>
                                <li>Profanity, hate speech, or discriminatory language.</li>
                                <li>Personal addresses, phone numbers, or identifiers.</li>
                                <li>Comments on personal/family life of the manager.</li>
                                <li>Accusations of criminal or HR violations.</li>
                                <li>Employment speculation (e.g., “this manager is about to be fired”).</li>
                                <li>URLs, promotions, or off-topic content.</li>
                                <li>Non-English content.</li>
                            </ul>

                            <h4 className='guidelines_text_h5'>Manager Guidelines</h4>
                            <ul className='guidelines_text_ul'>
                                <li>Managers cannot view reviewer identity — all reviews are anonymous.</li>
                                <li>Negative feedback will only be removed if it violates site policy.</li>
                                <li>Managers are encouraged to request feedback from team members to provide a broader set of insights.</li>
                                <li>Response to feedback must remain professional. Inflammatory replies will be removed.</li>
                                <li>Manager responses must also comply with these guidelines.</li>
                            </ul>

                            <h4 className='guidelines_text_h5'>Flagging a Rating</h4>
                            <p className='guidelines_text_p'>
                                You may report any review that violates these guidelines using the “Report This Rating” button. Moderators will review all reports, but we do not remove content solely for being unfavorable or unpopular.
                            </p>

                            <h4 className='guidelines_text_h5'>Legal Protection</h4>
                            <p className='guidelines_text_p'>
                                <b>Rate My Manager</b> is protected under the Communications Decency Act (47 U.S.C. § 230), which grants immunity to platforms hosting user-generated content. We are not legally liable for the reviews submitted by users.
                            </p>

                            <h4 className='guidelines_text_h5'>California CPRA / CCPA Disclaimer</h4>
                            <p className='guidelines_text_p'>
                                <b>Rate My Manager</b> is not subject to the California Consumer Privacy Act (CPRA/CCPA) as:
                            </p>
                            <ul className='guidelines_text_ul'>
                                <li>We do not generate over $25 million in annual gross revenue.</li>
                                <li>We do not buy, sell, or share consumer personal data.</li>
                                <li>We do not derive 50% or more of our revenue from selling personal information.</li>
                                <li>We do not share data with advertisers or third-party marketing platforms.</li>
                                <li>Users’ personal information is never sold, monetized, or used for targeted advertising.</li>
                            </ul>

                            <h4 className='guidelines_text_h5'>Reservation of Rights</h4>
                            <p className='guidelines_text_p'>
                                <b>Rate My Manager</b> reserves the right to remove any content that violates our guidelines or Terms of Use. We may also take legal or administrative action in cases involving threats or harmful conduct.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <CreateCompanyFooter/>
        </div>
    );
};

export default Legalguidelines;